<template>
  <div class="is-vertical-center notificationsContainer">
    <div>
      <h2 class="title">{{ $t("notification.your") }}</h2>

      <div
        :key="notification['.key']"
        v-for="notification in orderedList"
        class="notification"
      >
        <div class="notificationTitle">
          {{ notification.title }}
        </div>
        <div class="notificationDate">
          {{ formattedDate(notification.date) }}
          <a @click="confirmDelete(notification)">
            <b-icon class="clickable" icon="delete" size="is-small"></b-icon>
          </a>
        </div>
        <div class="notificationBody">
          {{ notification.body }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { mapState, mapActions } from "vuex";
import BIcon from "buefy/src/components/icon/Icon";

export default {
  components: { BIcon },
  name: "notifications",

  computed: {
    orderedList() {
      let notifications = JSON.parse(JSON.stringify(this.notifications));
      return notifications.sort((a, b) => new Date(b.date) - new Date(a.date));
    },

    ...mapState("user", {
      user: "current",
    }),
    ...mapState("notifications", {
      notifications: "list",
    }),
  },
  methods: {
    ...mapActions("notifications", {
      delete: "deleteNotification",
    }),

    formattedDate: function (timestamp) {
      var date = new Date(timestamp);

      var dmy = [
        ("0" + date.getDate()).slice(-2), // Get day and pad it with zeroes
        ("0" + (date.getMonth() + 1)).slice(-2), // Get month and pad it with zeroes
        date.getFullYear(), // Get full year
      ].join("/");

      var hm = [
        ("0" + date.getHours()).slice(-2), // Get day and pad it with zeroes
        ("0" + (date.getMinutes() + 1)).slice(-2), // Get month and pad it with zeroes
      ].join(":");

      return [dmy, hm].join(" ");
    },
    confirmDelete: function (notification) {
      this.$dialog.confirm({
        title: this.$t("notification.confirmTitle"),
        message: this.$t("notification.confirmText"),
        confirmText: this.$t("notification.accept"),
        cancelText: this.$t("notification.cancel"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteNotification(notification),
      });
    },

    deleteNotification: function (notification) {
      this.delete({ user: this.user, notification: notification });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 3rem 0 5rem;
  color: white;
}

.notificationsContainer {
  //height: 100%;
  background-image: url("/home/images/backgrounds/installations.jpg");
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
}

.notificationsContainer > div {
  width: 480px;
  max-width: 100%;
  margin: 0px auto;
  padding: 0 2rem;
}

.notification {
  padding: 1vw;
  border-radius: 15px;
  background-color: rgba(246, 244, 244, 0.91);
  margin: 0 auto;
  margin-bottom: 2vw;
  text-align: left;
}

.notificationTitle {
  float: left;
  font-weight: bold;
  cursor: pointer;
}

.notificationDate {
  text-align: right;
}

.clickable {
  cursor: pointer;
}
</style>
